export enum TypeService {
  gkl = "gkl",
  tkl = "tkl",
  hash = "hash"
}
